(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            container: '[data-component="Dom.FloatingMenu"]',
            sectionForMenu: '[data-floating-menu-label!=""][data-floating-menu-label]',
            sectionBody: '.product-section-body',
            menuItem: '.sidebar-menu-item',
            menuItemContainer: '.sidebar-menu-items',
            accordion: '[data-component="Dom.Accordion"]'
        },
        data: {
            floatingMenuLabel: 'floating-menu-label',
            floatingMenuIcon: 'floating-menu-icon'
        },
        classes: {
            faded: 'faded'
        },
        events: {
            click: 'click',
            scroll: 'scroll',
            accordionUpdate: 'accordion.hide accordion.show'
        },
        options: {}
    };

    ns.FloatingMenu = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.FloatingMenu.prototype = {
        init: function() {
            this.cacheItems();
            this.bindEvents();
            this.activate();
        },
        cacheItems: function() {
            let cache = this.settings.cache;

            this.winBody = $('html, body');
            this.sectionsForMenu = $(cache.sectionForMenu);
            this.window = $(window);

            this.menuItemContainer = this.container.find(cache.menuItemContainer);
            this.accordion = $(cache.accordion);
        },
        bindEvents: function() {
            let settings = this.settings,
                events = settings.events;

            this.originalContainerOffset = this.container.offset().top;
            window.addEventListener(
                events.scroll,
                () => {
                    let scrollOffset = this.window.scrollTop();

                    if (scrollOffset > this.originalContainerOffset) {
                        if (scrollOffset < this.maxOffset) {
                            this.container.css(
                                'transform',
                                'translateY(' +
                                    (scrollOffset - this.originalContainerOffset + 100) +
                                    'px)'
                            );
                        } else {
                            this.container.css(
                                'transform',
                                'translateY(' +
                                    this.maxOffset -
                                    this.originalContainerOffset +
                                    100 +
                                    'px)'
                            );
                        }
                    } else if (scrollOffset < this.originalContainerOffset) {
                        this.container.css('transform', 'translateY(' + 0 + 'px)');
                    }
                },
                {
                    passive: true
                }
            );

            this.accordion.on(events.accordionUpdate, () => {
                this.calculateMaxOffset();
            });
        },
        activate: function() {
            let settings = this.settings,
                data = settings.data,
                events = settings.events,
                itemCount = 0;

            // timeout 0 to allow empty sections to hide themselves (see Views\DOM\Product\Section.cshtml)
            // Needs to become listener to all sections for promises
            if (!this.sectionsForMenu.length) {
                this.container.parent().hide();
            } else {
                this.menuItemContainer.html('');
            }

            for (let i = 0; i < this.sectionsForMenu.length; i++) {
                let sectionForMenu = this.sectionsForMenu.eq(i);
                if (this.hideEmptySection(sectionForMenu)) {
                    continue;
                }
                itemCount++;

                let menuItemLabel = sectionForMenu.data(data.floatingMenuLabel);
                let menuItemIcon = sectionForMenu.data(data.floatingMenuIcon);

                let menuItemLink = $('<a href="#">' + menuItemLabel + '</a>');
                let menuItem = $('<li class="sidebar-menu-item"></li>');
                menuItem.append(menuItemLink);

                const header = $('.deny header, .neu header, .omni header, .antipanic header');
                var fixedHeaderHeight = 0;
                if (header && header.length) {
                    fixedHeaderHeight = header.outerHeight();
                }

                menuItemLink.on(events.click, () => {
                    this.winBody.animate(
                        {
                            scrollTop: sectionForMenu.offset().top - fixedHeaderHeight
                        },
                        500
                    );
                    return false;
                });

                if (menuItemIcon) {
                    menuItemLink.append($('<i class="fa ' + menuItemIcon + '"></i>'));
                }
                this.menuItemContainer.append(menuItem);
            }

            if (itemCount <= 2) {
                this.container.parent().remove();
            }

            this.calculateMaxOffset();
        },
        calculateMaxOffset: function() {
            setTimeout(() => {
                this.maxOffset =
                    this.container.parent().height() -
                    this.container.outerHeight() +
                    this.originalContainerOffset -
                    250;

                // 250 for extra margin
            }, 500);
        },
        hideEmptySection: function(section) {
            let cache = this.settings.cache;
            let body = section.find(cache.sectionBody);

            if (
                body &&
                body.length &&
                body.text().trim().length === 0 &&
                body.find('img').length === 0
            ) {
                section.remove();
                return true;
            }
            return false;
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
